export default class BreadcrumbService {

    get_home() 
    {  
        
        let home={icon: 'pi pi-home',to: '/'+localStorage.getItem("Breadcrumb_home")};
		return home;
	}
    getBreadcrum(label,to) 
    {    
        let items=  [{label: label,to:to}]
        let data={
            home:this.get_home(),
            items:items
        }
        
		return data;
	}







}